import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useLocale } from 'next-intl';
import FilterSettings from './components/filter-settings/filter-settings';
import FilterResults from './components/filter-results/filter-results';

import { buildDataUrl } from '../../../helper/api';

const BookingFilter = () => {
  const [results, setResults] = useState();
  const [settings, setSettings] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const locale = useLocale();

  const onSelectionChange = async selection => {
    setSettings(selection);
    setLoading(true);
    setError(false);

    // for some reason react-calendar returns dates in different timezones. This function normalizez the date and return it without a timezone.
    const handleDateTimezoneOffset = dateToNormalize => {
      const offset = dateToNormalize.getTimezoneOffset();
      const normalizedDate = new Date(dateToNormalize.getTime() - offset * 60 * 1000);
      return normalizedDate.toISOString().split('T')[0];
    };

    // if dropdown selection empty, get all results
    const querySelection = selection;
    if (!querySelection.type) {
      querySelection.browse = ['events,festivals,guidedTours'];
    }

    const queryParams = {
      ...querySelection,
      date: handleDateTimezoneOffset(selection.date)
    };

    const response = await fetch(
      `${buildDataUrl(
        `${locale || 'de'}/${process.env.NEXT_PUBLIC_JSON_API_PATH}/calendarfilter`
      )}?${new URLSearchParams(queryParams).toString()}`,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
      .then(res => res.json())
      .catch(e => setError(e));

    setResults(response);
    setLoading(false);
  };

  return (
    <>
      <FilterSettings onSelectionChange={onSelectionChange} results={results} />
      <FilterResults settings={settings} loading={loading} error={error} results={results} />
    </>
  );
};

const mapStateToProps = ({ app: { pageData } }) => ({
  lang: pageData.lang
});

export default connect(mapStateToProps)(BookingFilter);
